module.exports = __webpack_public_path__ + "img/ico-sns-tid.2e7dde4a.svg";